module.exports = __webpack_public_path__ + "img/download.544a5cd8.svg";